import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	other: {
		id: 'eoc.routing-rules.ui.other.no-translate',
		defaultMessage: 'Other',
		description: 'The label of other group when will be shown on select options',
	},
	escalations: {
		id: 'eoc.routing-rules.ui.escalations.no-translate',
		defaultMessage: 'Escalation(s)',
		description: 'The label of escalations group when will be shown on select options',
	},
	schedules: {
		id: 'eoc.routing-rules.ui.schedules.no-translate',
		defaultMessage: 'Schedule(s)',
		description: 'The label of schedules group when will be shown on select options',
	},
	noOne: {
		id: 'eoc.routing-rules.ui.no-one.no-translate',
		defaultMessage: 'No one',
		description: 'The label of other group option',
	},
});

export default messages;
